import { DependencyInjector } from '@wittignl/js-core'

export default new DependencyInjector();